import BaseAuthenticationModel from "scripts/models/baseAuthenticationModel";

class OrganizationAuthenticationModel extends BaseAuthenticationModel {
  url() {
    return `${this.organizationAuthenticationUrlRoot}/authentication`;
  }
}

export default OrganizationAuthenticationModel;
